import { Fragment, useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import DatePicker from "react-datepicker";
import { GoDotFill } from "react-icons/go";
import { MdDateRange } from "react-icons/md";
import useCalendarHook from "../../hooks/useCalendarHook";
import useLeaveHook from "../../hooks/useLeaveHook";

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

export default (props: any) => {
  var { pickedRole, setPickedRole } = props.hook;
  const { OrgLeaveReq } = useLeaveHook();
  useEffect(() => {
    setPickedRole(props.defaultvalue);
  }, []);
  const [showModal, setshowModal] = useState(false);

  const [value, onChange] = useState<Value>(new Date());

  useEffect(() => {
    let d = value as Date;
    setPickedRole({ code: value, name: d?.toDateString() });
    setshowModal(false);
  }, [value]);
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const { holidays, weekends } = useCalendarHook();
  const [weekendsdays, setweekendsdays] = useState<string[]>([]);

  useEffect(() => {
    let emptarr: any = [];
    weekends.map((kk: any) => {
      emptarr.push(kk.days);
      setweekendsdays(emptarr); });
    console.log(emptarr);
  }, [weekends]);

  return (
    <div className="my-4 max-w-[200px] relative ">
      <p className="text-xs mb-2 flex  items-center">
        {props.title} {props.tooltip}
      </p>
      <div
        onClick={() => {
          setshowModal(true);
        }}
        className=" px-4 py-1   flex text-sm bg-white w-full  rounded-[8px]  border-2 border-gray-200 items-center"
      >
        <MdDateRange className="text-gray-400 z-[0]" size={20} />
        {/* 
          <DatePicker
            className="font-light"
            selected={pickedRole.code}
            onChange={(date) => {
              setPickedRole({ code: date, name: date?.toDateString() });
            }}   /> */}
        <p>{pickedRole.name}</p>

        {showModal && (
          <div
            onClick={() => {
              setshowModal(false);
            }}
            className="absolute z-[30] p-1 bg-[#0000007f] rounded flex justify-center items-center flex-col"
          >
            <Calendar
              className={"scale-75"}
              tileContent={({ activeStartDate, date, view }) => (
                <div>
                  {OrgLeaveReq.map((item: any) => {
                    var itemdate = new Date(item.startDate);

                    return (
                      <>
                        {view === "month" &&
                          date.getDate() === itemdate.getDate() &&
                          date.getMonth() === itemdate.getMonth() &&
                          date.getFullYear() === itemdate.getFullYear() && (
                            <p className="relative ">
                              {" "}
                              <GoDotFill
                                size={15}
                                className={`${
                                  item.status == "pending" ||
                                  item.status == "rejected"
                                    ? "text-[#F79009] mx-1"
                                    : ""
                                }  ${
                                  item.status == "approved"
                                    ? "text-green-400"
                                    : ""
                                } inline `}
                              />
                              <span className="    rounded px-1 block text-[10px] z-[100]  ">
                                {" "}
                                {item.status}
                              </span>
                            </p>
                          )}{" "}
                      </>
                    );
                  })}

                  {view === "month" &&
                    weekendsdays.includes(daysOfWeek[date.getDay()]) && (
                      <div className="text-[10px] text-primary">Weekend</div>
                    )}
                  {holidays.map((iy: any) => {
                    return (
                      <>
                        {view === "month" &&
                          date.getDate() === new Date(iy.startDate).getDate() &&
                          date.getMonth() ===
                            new Date(iy.startDate).getMonth() && (
                            <p className="relative  text-green-700 ">
                              <GoDotFill
                                size={15}
                                className={` text-green-700 `}
                              />
                              <span className="    rounded px-1 block text-[10px] z-[100]  ">
                                {iy.title}
                              </span>
                            </p>
                          )}
                      </>
                    );
                  })}
                </div>
              )}
              onChange={onChange}
              value={value}
            />
          </div>
        )}
      </div>
    </div>
  );
};
